import { useEffect, useState } from 'react';
import { api } from './api';

/**
 * Polja koja prijavljeni korisnik NE smije unositi.
 *
 * Ekran za unos po ovome ne iscrtava oduzeta polja. Ovo je samo prikaz —
 * pravu provjeru radi backend pri spremanju (services/polja.py), pa sakriveno
 * polje nije i jedina brana.
 *
 * Odgovor se pamti u modulu: ekran Postavki iscrtava pet formi po uposleniku,
 * pa bi svaka inače povukla isti spisak zasebno.
 */
let kes: Promise<Set<string>> | null = null;
let kesOd = 0;

// Keš traje kratko: kad direktor nekom oduzme polje, ta osoba to vidi čim
// ponovo otvori ekran, bez odjave i prijave. Dovoljno dugo da pet formi
// jednog uposlenika ne povuče isti spisak pet puta.
const TRAJANJE = 60_000;

/** Pri promjeni prijavljenog korisnika — keš jednog ne smije važiti za drugog. */
export function ocistiZabrane() {
  kes = null;
}

function dohvati(): Promise<Set<string>> {
  if (!kes || Date.now() - kesOd > TRAJANJE) {
    kesOd = Date.now();
    kes = api.get('/api/korisnici/moje')
      .then(r => new Set<string>(r.data.zabranjena_polja || []))
      // Ako spisak ne stigne, ne skrivamo ništa — backend ionako odbija
      // nedozvoljenu izmjenu, pa je gore sakriti polje nego ga pokazati.
      .catch(() => new Set<string>());
  }
  return kes;
}

export function useZabrane() {
  const [zabrane, setZabrane] = useState<Set<string> | null>(null);

  useEffect(() => {
    let ziv = true;
    dohvati().then(z => { if (ziv) setZabrane(z); });
    return () => { ziv = false; };
  }, []);

  return {
    ucitano: zabrane !== null,
    // Dok spisak ne stigne, ništa se ne smije: ranije je "nepoznato" značilo
    // "dozvoljeno", pa se zabranjena polja vide 1–2 sekunde prije nego nestanu.
    smije: (polje: string) => zabrane !== null && !zabrane.has(polje),
    /** Ima li u sekciji ijedno polje koje smije — ako nema, sekcija se ne crta. */
    smijeIjedno: (polja: string[]) => zabrane !== null && polja.some(p => !zabrane.has(p)),
  };
}
